type ContentBlock = { type: "p" | "h2"; text: string };

interface PostContentProps {
  content: ContentBlock[];
}

export default function PostContent({ content }: PostContentProps) {
  return (
    <div className="max-w-2xl mx-auto">
      {content.map((block, i) => {
        if (block.type === "h2") {
          return (
            <h2
              key={i}
              className="text-black text-2xl md:text-3xl font-black uppercase mt-12 mb-4 leading-tight"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              {block.text}
            </h2>
          );
        }
        return (
          <p
            key={i}
            className="text-black/70 text-base leading-[1.9] mb-6"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            {block.text}
          </p>
        );
      })}
    </div>
  );
}
